{
  "version": 2,
  "reader": {
    "schemaMajor": 1,
    "maxBundles": 8,
    "maxBundleJsonBytes": 524288,
    "excludedScopes": [
      8,
      "CLIENT_FACT_SCOPE_INSTALLATION"
    ],
    "bindingContext": "^otlp\\.(resource|scope|record)\\.",
    "scalarKeys": [
      "stringValue",
      "booleanValue",
      "integerValue",
      "intValue",
      "uuidValue"
    ],
    "defaultValueKey": "stringValue",
    "typedValueKeys": {
      "first_party.origin_dashboard": "booleanValue"
    },
    "extractSyntax": "^\\^?(?:(?:[^\\\\()\\[\\]{}.*+?^$|]|\\\\[.\\\\()\\[\\]{}*+?^$|]|\\\\[dDwWsS]|\\.|\\[\\^?(?:[^\\\\\\[\\]]|\\\\[\\\\\\[\\]^-])+\\])(?:[*+?]|\\{[0-9]+(?:,[0-9]*)?\\})?)*\\((?:(?:[^\\\\()\\[\\]{}.*+?^$|]|\\\\[.\\\\()\\[\\]{}*+?^$|]|\\\\[dDwWsS]|\\.|\\[\\^?(?:[^\\\\\\[\\]]|\\\\[\\\\\\[\\]^-])+\\])(?:[*+?]|\\{[0-9]+(?:,[0-9]*)?\\})?)+\\)(?:(?:[^\\\\()\\[\\]{}.*+?^$|]|\\\\[.\\\\()\\[\\]{}*+?^$|]|\\\\[dDwWsS]|\\.|\\[\\^?(?:[^\\\\\\[\\]]|\\\\[\\\\\\[\\]^-])+\\])(?:[*+?]|\\{[0-9]+(?:,[0-9]*)?\\})?)*\\$?$"
  },
  "identities": {
    "github-copilot": {
      "productId": "github-copilot",
      "key": "github-copilot",
      "name": "GitHub Copilot"
    },
    "copilot-vscode": {
      "productId": "github-copilot",
      "key": "github-copilot",
      "name": "GitHub Copilot",
      "host": "vscode"
    },
    "copilot-cli": {
      "productId": "github-copilot",
      "key": "github-copilot",
      "name": "GitHub Copilot",
      "interface": "cli"
    },
    "claude-code": {
      "productId": "claude-code",
      "key": "claude",
      "name": "Claude Code"
    },
    "claude-code-cli": {
      "productId": "claude-code",
      "key": "claude",
      "name": "Claude Code",
      "interface": "cli"
    },
    "claude-code-desktop": {
      "productId": "claude-code",
      "key": "claude",
      "name": "Claude Code",
      "host": "claude-desktop",
      "interface": "desktop"
    },
    "claude-cowork": {
      "productId": "claude-cowork",
      "key": "claude",
      "name": "Claude Cowork"
    },
    "claude-agent-sdk": {
      "productId": "claude-agent-sdk",
      "key": "claude",
      "name": "Claude Agent SDK"
    },
    "claude-agent-sdk-ts": {
      "productId": "claude-agent-sdk",
      "key": "claude",
      "name": "Claude Agent SDK",
      "sdkLanguage": "typescript"
    },
    "claude-agent-sdk-py": {
      "productId": "claude-agent-sdk",
      "key": "claude",
      "name": "Claude Agent SDK",
      "sdkLanguage": "python"
    },
    "claude-office": {
      "productId": "claude-addin",
      "key": "claude",
      "name": "Claude",
      "interface": "addin",
      "genericName": "Claude add-in"
    },
    "claude-excel": {
      "productId": "claude-addin",
      "key": "claude",
      "name": "Claude",
      "host": "excel",
      "interface": "addin",
      "genericName": "Claude add-in"
    },
    "claude-word": {
      "productId": "claude-addin",
      "key": "claude",
      "name": "Claude",
      "host": "word",
      "interface": "addin",
      "genericName": "Claude add-in"
    },
    "claude-powerpoint": {
      "productId": "claude-addin",
      "key": "claude",
      "name": "Claude",
      "host": "powerpoint",
      "interface": "addin",
      "genericName": "Claude add-in"
    },
    "claude-outlook": {
      "productId": "claude-addin",
      "key": "claude",
      "name": "Claude",
      "host": "outlook",
      "interface": "addin",
      "genericName": "Claude add-in"
    },
    "claude-chat": {
      "productId": "claude-chat",
      "key": "claude",
      "name": "Claude chat"
    },
    "claude-web": {
      "productId": "claude-chat",
      "key": "claude",
      "name": "Claude chat",
      "interface": "web"
    },
    "codex": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex"
    },
    "codex-cli": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex",
      "interface": "cli"
    },
    "codex-web": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex",
      "interface": "web"
    },
    "codex-vscode": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex",
      "host": "vscode"
    },
    "cursor": {
      "productId": "cursor",
      "key": "cursor",
      "name": "Cursor"
    },
    "gemini-cli": {
      "productId": "gemini-cli",
      "key": "gemini",
      "name": "Gemini CLI",
      "interface": "cli"
    },
    "gemini-docs": {
      "productId": "gemini",
      "key": "gemini",
      "name": "Gemini",
      "host": "docs",
      "interface": "web"
    },
    "gemini-sheets": {
      "productId": "gemini",
      "key": "gemini",
      "name": "Gemini",
      "host": "sheets",
      "interface": "web"
    },
    "gemini-slides": {
      "productId": "gemini",
      "key": "gemini",
      "name": "Gemini",
      "host": "slides",
      "interface": "web"
    },
    "gemini-web": {
      "productId": "gemini",
      "key": "gemini",
      "name": "Gemini",
      "interface": "web"
    },
    "grok-build": {
      "productId": "grok-build",
      "key": "xai",
      "name": "Grok Build"
    },
    "chatgpt": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT"
    },
    "chatgpt-web": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "web"
    },
    "chatgpt-macos": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "desktop",
      "operatingSystem": "macos"
    },
    "chatgpt-windows": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "desktop",
      "operatingSystem": "windows"
    },
    "chatgpt-ios": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "mobile",
      "operatingSystem": "ios"
    },
    "chatgpt-android": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "mobile",
      "operatingSystem": "android"
    },
    "chatgpt-android-web": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "web",
      "operatingSystem": "android"
    },
    "chatgpt-api": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "api"
    },
    "chatgpt-spreadsheet": {
      "productId": "chatgpt-spreadsheet",
      "key": "chatgpt",
      "name": "ChatGPT spreadsheet add-in",
      "parentProductId": "chatgpt",
      "interface": "addin"
    },
    "deepseek-web": {
      "productId": "deepseek",
      "key": "deepseek",
      "name": "DeepSeek",
      "interface": "web"
    },
    "perplexity": {
      "productId": "perplexity",
      "key": "perplexity",
      "name": "Perplexity"
    },
    "perplexity-web": {
      "productId": "perplexity",
      "key": "perplexity",
      "name": "Perplexity",
      "interface": "web"
    },
    "perplexity-comet": {
      "productId": "perplexity-comet",
      "key": "perplexity",
      "name": "Perplexity Comet"
    },
    "perplexity-computer": {
      "productId": "perplexity-computer",
      "key": "perplexity",
      "name": "Perplexity Computer"
    },
    "microsoft-copilot-web": {
      "productId": "microsoft-copilot",
      "key": "copilot",
      "name": "Microsoft Copilot",
      "interface": "web"
    },
    "m365-copilot": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot"
    },
    "m365-excel": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "excel"
    },
    "m365-word": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "word"
    },
    "m365-powerpoint": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "powerpoint"
    },
    "m365-teams": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "teams"
    },
    "m365-outlook": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "outlook"
    },
    "m365-onenote": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "onenote"
    },
    "m365-loop": {
      "productId": "m365-copilot",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot",
      "host": "loop"
    },
    "m365-bizchat": {
      "productId": "m365-copilot-chat",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot Chat",
      "parentProductId": "m365-copilot"
    },
    "m365-webchat": {
      "productId": "m365-copilot-chat",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot Chat",
      "parentProductId": "m365-copilot"
    },
    "m365-chat-web": {
      "productId": "m365-copilot-chat",
      "key": "m365copilot",
      "name": "Microsoft 365 Copilot Chat",
      "parentProductId": "m365-copilot",
      "interface": "web"
    },
    "origin-dashboard": {
      "productId": "origin-dashboard",
      "key": "origin",
      "name": "Origin Dashboard",
      "clientKind": "first_party"
    },
    "codex-desktop": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex",
      "interface": "desktop"
    },
    "codex-sdk-ts": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex",
      "sdkLanguage": "typescript"
    },
    "chatgpt-ios-web": {
      "productId": "chatgpt",
      "key": "chatgpt",
      "name": "ChatGPT",
      "interface": "web",
      "operatingSystem": "ios"
    },
    "chatgpt-sheets": {
      "productId": "chatgpt-spreadsheet",
      "key": "chatgpt",
      "name": "ChatGPT",
      "parentProductId": "chatgpt",
      "interface": "addin",
      "host": "sheets",
      "genericName": "ChatGPT spreadsheet add-in"
    },
    "chatgpt-excel": {
      "productId": "chatgpt-spreadsheet",
      "key": "chatgpt",
      "name": "ChatGPT",
      "parentProductId": "chatgpt",
      "interface": "addin",
      "host": "excel",
      "genericName": "ChatGPT spreadsheet add-in"
    },
    "codex-github-actions": {
      "productId": "codex",
      "key": "codex",
      "name": "Codex",
      "host": "github-actions"
    }
  },
  "maps": {
    "CLIENTS": {
      "github-copilot": "github-copilot",
      "copilot-chat": "copilot-vscode",
      "claude-code": "claude-code",
      "claude-code-desktop": "claude-code-desktop",
      "codex-cli": "codex-cli",
      "codex": "codex",
      "cursor": "cursor",
      "gemini-cli": "gemini-cli",
      "grok-build": "grok-build"
    },
    "OFFICE": {
      "sheet": "claude-excel",
      "doc": "claude-word",
      "slide": "claude-powerpoint",
      "mail": "claude-outlook"
    },
    "M365_APPS": {
      "Excel": "m365-excel",
      "Word": "m365-word",
      "PowerPoint": "m365-powerpoint",
      "Teams": "m365-teams",
      "Outlook": "m365-outlook",
      "OneNote": "m365-onenote",
      "Loop": "m365-loop",
      "BizChat": "m365-bizchat",
      "WebChat": "m365-webchat"
    },
    "OPENAI_CLIENT_TYPES": {
      "desktop_web": "chatgpt-web",
      "macos_app": "chatgpt-macos",
      "windows_app": "chatgpt-windows",
      "ios_app": "chatgpt-ios",
      "android_app": "chatgpt-android",
      "android_web": "chatgpt-android-web",
      "chatgpt_api": "chatgpt-api",
      "ios_web": "chatgpt-ios-web"
    },
    "OPENAI_CODEX_CLIENTS": {
      "CODEX_CLI": "codex-cli",
      "CODEX_WEB": "codex-web",
      "CODEX_IDE_VSCODE": "codex-vscode",
      "CODEX_DESKTOP_APP": "codex-desktop",
      "CODEX_SDK_TS": "codex-sdk-ts",
      "CODEX_GITHUB_ACTION": "codex-github-actions",
      "CODEX_SERVICE_EXEC": "codex",
      "CODEX_UNKNOWN_DEFAULT": "codex"
    },
    "BROWSER": {
      "openai": "chatgpt-web",
      "anthropic": "claude-web",
      "deepseek": "deepseek-web",
      "perplexity": "perplexity-web"
    },
    "MICROSOFT_ORIGINS": {
      "https://copilot.microsoft.com": "microsoft-copilot-web",
      "https://copilot.cloud.microsoft": "m365-chat-web",
      "https://m365.cloud.microsoft": "m365-chat-web",
      "https://m365copilot.com": "m365-chat-web"
    },
    "ENTRYPOINTS": {
      "cli": "claude-code-cli",
      "claude-desktop": "claude-code-desktop",
      "local-agent": "claude-cowork",
      "sdk-cli": "claude-agent-sdk",
      "sdk-ts": "claude-agent-sdk-ts",
      "sdk-py": "claude-agent-sdk-py"
    },
    "GOOGLE_APPS": {
      "gemini-docs": "gemini-docs",
      "gemini-sheets": "gemini-sheets",
      "gemini-slides": "gemini-slides"
    },
    "PERPLEXITY": {
      "query": "perplexity",
      "answer_generated": "perplexity",
      "comet_agent_action": "perplexity-comet",
      "computer_task_started": "perplexity-computer",
      "computer_agent_action": "perplexity-computer",
      "computer_task_completed": "perplexity-computer",
      "computer_task_error": "perplexity-computer"
    },
    "OPENAI_SPREADSHEET_CLIENTS": {
      "BASISPOINTS_SHEETS_ADDIN": "chatgpt-sheets",
      "BASISPOINTS_EXCEL_ADDIN": "chatgpt-excel"
    }
  },
  "rules": [
    {
      "field": "hook.client",
      "map": "CLIENTS",
      "ambiguous": true
    },
    {
      "field": "transcript.family",
      "map": "CLIENTS",
      "ambiguous": true
    },
    {
      "field": "otlp.resource.service.name",
      "map": "CLIENTS",
      "ambiguous": true
    },
    {
      "field": "otlp.scope.name",
      "map": "CLIENTS",
      "ambiguous": true
    },
    {
      "when": [
        {
          "field": "otlp.resource.service.name",
          "equals": "github-copilot",
          "single": true
        },
        {
          "field": "otlp.resource.service.namespace",
          "equals": "vscode.agent-host",
          "single": true
        }
      ],
      "surface": "copilot-vscode"
    },
    {
      "field": "request.anthropic.cc_entrypoint",
      "map": "ENTRYPOINTS",
      "ambiguous": true,
      "suppress": [
        "claude-code"
      ]
    },
    {
      "when": [
        {
          "field": "transcript.host_mode",
          "values": ["cowork_full_vm", "cowork_host_loop"],
          "single": true
        }
      ],
      "surface": "claude-cowork",
      "suppress": [
        "claude-code"
      ]
    },
    {
      "when": [
        {
          "field": "otlp.resource.service.name",
          "values": [
            "office-agent",
            "office-agents"
          ],
          "single": true
        }
      ],
      "surface": "claude-office"
    },
    {
      "when": [
        {
          "field": "otlp.resource.service.name",
          "values": [
            "office-agent",
            "office-agents"
          ],
          "single": true
        }
      ],
      "field": "otlp.record.agent.surface",
      "map": "OFFICE"
    },
    {
      "any": [
        {
          "field": "connector.m365.app_class",
          "present": true
        },
        {
          "field": "connector.m365.resource_kind",
          "equals": "interaction",
          "single": true
        },
        {
          "field": "connector.m365.audit.app_host",
          "present": true
        }
      ],
      "surface": "m365-copilot"
    },
    {
      "any": [
        {
          "field": "connector.m365.app_class",
          "present": true
        },
        {
          "field": "connector.m365.resource_kind",
          "equals": "interaction",
          "single": true
        },
        {
          "field": "connector.m365.audit.app_host",
          "present": true
        }
      ],
      "field": "connector.m365.app_class",
      "extract": "^IPM\\.SkypeTeams\\.Message\\.Copilot\\.([^.]+)$",
      "map": "M365_APPS"
    },
    {
      "any": [
        {
          "field": "connector.m365.app_class",
          "present": true
        },
        {
          "field": "connector.m365.resource_kind",
          "equals": "interaction",
          "single": true
        },
        {
          "field": "connector.m365.audit.app_host",
          "present": true
        }
      ],
      "field": "connector.m365.audit.app_host",
      "map": "M365_APPS",
      "ambiguous": true
    },
    {
      "when": [
        {
          "field": "connector.anthropic.resource_kind",
          "equals": "chat",
          "single": true
        }
      ],
      "surface": "claude-chat"
    },
    {
      "when": [
        {
          "field": "connector.openai.record_type",
          "equals": "CONVERSATION_MESSAGE",
          "single": true
        }
      ],
      "surface": "chatgpt"
    },
    {
      "when": [
        {
          "field": "connector.openai.record_type",
          "equals": "CONVERSATION_MESSAGE",
          "single": true
        }
      ],
      "field": "connector.openai.client_type",
      "map": "OPENAI_CLIENT_TYPES"
    },
    {
      "when": [
        {
          "field": "connector.openai.record_type",
          "equals": "CODEX_LOG",
          "single": true
        }
      ],
      "surface": "codex"
    },
    {
      "when": [
        {
          "field": "connector.openai.record_type",
          "equals": "CODEX_LOG",
          "single": true
        }
      ],
      "field": "connector.openai.client_id",
      "map": "OPENAI_CODEX_CLIENTS"
    },
    {
      "when": [
        {
          "field": "connector.openai.record_type",
          "equals": "CHATGPT_PLUGIN_SPREADSHEET",
          "single": true
        }
      ],
      "surface": "chatgpt-spreadsheet"
    },
    {
      "when": [
        {
          "field": "connector.openai.record_type",
          "equals": "CHATGPT_PLUGIN_SPREADSHEET",
          "single": true
        }
      ],
      "field": "connector.openai.client_id",
      "map": "OPENAI_SPREADSHEET_CLIENTS",
      "suppress": [
        "chatgpt-spreadsheet"
      ]
    },
    {
      "field": "browser.recipe_provider",
      "single": true,
      "map": "BROWSER"
    },
    {
      "when": [
        {
          "field": "browser.recipe_provider",
          "equals": "google",
          "single": true
        },
        {
          "field": "browser.client_surface",
          "values": [
            "gemini-docs",
            "gemini-sheets",
            "gemini-slides"
          ],
          "single": true
        }
      ],
      "field": "browser.client_surface",
      "single": true,
      "map": "GOOGLE_APPS"
    },
    {
      "when": [
        {
          "field": "browser.recipe_provider",
          "equals": "google",
          "single": true
        },
        {
          "field": "browser.page_origin",
          "equals": "https://gemini.google.com",
          "single": true
        },
        {
          "field": "browser.client_surface",
          "notIn": [
            "gemini-docs",
            "gemini-sheets",
            "gemini-slides"
          ]
        }
      ],
      "surface": "gemini-web"
    },
    {
      "when": [
        {
          "field": "browser.recipe_provider",
          "equals": "microsoft",
          "single": true
        }
      ],
      "field": "browser.page_origin",
      "single": true,
      "map": "MICROSOFT_ORIGINS"
    },
    {
      "field": "connector.perplexity.event_type",
      "map": "PERPLEXITY"
    },
    {
      "when": [
        {
          "field": "first_party.origin_dashboard",
          "equals": true,
          "single": true
        }
      ],
      "surface": "origin-dashboard"
    }
  ],
  "categories": {
    "github-copilot": {
      "productId": "github-copilot",
      "host": null
    },
    "copilot-vscode": {
      "productId": "github-copilot",
      "host": "vscode"
    },
    "claude-code": {
      "productId": "claude-code",
      "host": null
    },
    "claude-code-desktop": {
      "productId": "claude-code",
      "host": "claude-desktop"
    },
    "claude-cowork": {
      "productId": "claude-cowork",
      "host": null
    },
    "claude-agent-sdk": {
      "productId": "claude-agent-sdk",
      "host": null
    },
    "claude-office": {
      "productId": "claude-addin",
      "host": null
    },
    "claude-excel": {
      "productId": "claude-addin",
      "host": "excel"
    },
    "claude-word": {
      "productId": "claude-addin",
      "host": "word"
    },
    "claude-powerpoint": {
      "productId": "claude-addin",
      "host": "powerpoint"
    },
    "claude-outlook": {
      "productId": "claude-addin",
      "host": "outlook"
    },
    "claude-chat": {
      "productId": "claude-chat",
      "host": null
    },
    "codex": {
      "productId": "codex",
      "host": null
    },
    "codex-vscode": {
      "productId": "codex",
      "host": "vscode"
    },
    "cursor": {
      "productId": "cursor",
      "host": null
    },
    "gemini-cli": {
      "productId": "gemini-cli",
      "host": null
    },
    "gemini-docs": {
      "productId": "gemini",
      "host": "docs"
    },
    "gemini-sheets": {
      "productId": "gemini",
      "host": "sheets"
    },
    "gemini-slides": {
      "productId": "gemini",
      "host": "slides"
    },
    "gemini-web": {
      "productId": "gemini",
      "host": null
    },
    "grok-build": {
      "productId": "grok-build",
      "host": null
    },
    "chatgpt": {
      "productId": "chatgpt",
      "host": null
    },
    "chatgpt-spreadsheet": {
      "productId": "chatgpt-spreadsheet",
      "host": null
    },
    "deepseek-web": {
      "productId": "deepseek",
      "host": null
    },
    "perplexity": {
      "productId": "perplexity",
      "host": null
    },
    "perplexity-comet": {
      "productId": "perplexity-comet",
      "host": null
    },
    "perplexity-computer": {
      "productId": "perplexity-computer",
      "host": null
    },
    "microsoft-copilot-web": {
      "productId": "microsoft-copilot",
      "host": null
    },
    "m365-copilot": {
      "productId": "m365-copilot",
      "host": null
    },
    "m365-excel": {
      "productId": "m365-copilot",
      "host": "excel"
    },
    "m365-word": {
      "productId": "m365-copilot",
      "host": "word"
    },
    "m365-powerpoint": {
      "productId": "m365-copilot",
      "host": "powerpoint"
    },
    "m365-teams": {
      "productId": "m365-copilot",
      "host": "teams"
    },
    "m365-outlook": {
      "productId": "m365-copilot",
      "host": "outlook"
    },
    "m365-onenote": {
      "productId": "m365-copilot",
      "host": "onenote"
    },
    "m365-loop": {
      "productId": "m365-copilot",
      "host": "loop"
    },
    "m365-bizchat": {
      "productId": "m365-copilot-chat",
      "host": null
    },
    "origin-dashboard": {
      "productId": "origin-dashboard",
      "host": null
    },
    "chatgpt-sheets": {
      "productId": "chatgpt-spreadsheet",
      "host": "sheets"
    },
    "chatgpt-excel": {
      "productId": "chatgpt-spreadsheet",
      "host": "excel"
    },
    "codex-github-actions": {
      "productId": "codex",
      "host": "github-actions"
    }
  },
  "statuses": {
    "unknown": "Unknown harness",
    "conflicting": "Conflicting harness evidence",
    "multiple": "Multiple harnesses"
  },
  "hostLabels": {
    "vscode": "VS Code",
    "claude-desktop": "Claude Desktop",
    "chrome": "Chrome",
    "excel": "Microsoft Excel",
    "word": "Microsoft Word",
    "powerpoint": "Microsoft PowerPoint",
    "outlook": "Microsoft Outlook",
    "teams": "Microsoft Teams",
    "onenote": "Microsoft OneNote",
    "loop": "Microsoft Loop",
    "docs": "Google Docs",
    "sheets": "Google Sheets",
    "slides": "Google Slides",
    "github-actions": "GitHub Actions"
  }
}
